import { gql } from '@apollo/client'

export const GET_ORGANISATION_EMPLOYEES = gql`
  query getOrganisationEmployees(
    $id: ID!
    $first: Int!
    $after: Int!
    $searchterm: String
    $activeDate: Time
  ) {
    organisation(id: $id) {
      id
      employees(
        pagination: { after: $after, first: $first }
        searchterm: $searchterm
        activeDate: $activeDate
        orderBy: [{ field: id, order: DESC }]
      ) {
        totalCount
        pageInfo {
          endCursor
          hasNextPage
        }
        employees {
          id
          externalReference
          rentCategoryTierID
          contact {
            id
            firstName
            lastName
            email
            phoneNumber
          }
          rentals {
            totalCount
            rentals {
              stocklistItem {
                imei
              }
              deviceDefinition {
                name
                productType
              }
            }
          }
          tags {
            __typename
            id
            name
            color
            inherited
            inheritedFrom
          }
        }
      }
    }
  }
`

export const GET_ALLOWED_EMPLOYEES = gql`
  query getAllowedEmployees {
    allowedEmployees {
      employees {
        contact {
          firstName
          id
          lastName
        }
        id
      }
      totalCount
    }
  }
`
